export default {"src":"/_next/static/media/scan.c799d318.svg","height":72,"width":72};